import z from "zod";

const flag = z
  .string()
  .optional()
  .transform((value) => undefined !== value && "false" !== value);

export const contractEditorDataSchema = z.object({
  projectId: z.coerce.number().int().positive(),

  contractId: z
    .string()
    .optional()
    .transform((value) => {
      const id = Number(value);

      return value && Number.isInteger(id) && id > 0 ? id : null;
    }),
  contained: flag,
  open: flag,
});

export type ContractEditorDataProps = z.infer<typeof contractEditorDataSchema>;
